import * as types from './types'
import { IPaginatedRequest } from '@cbgms/api/request'
import { ILedger } from '@cbgms/api/modules/ledgers'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { AdministrationListResponse, AdministrationResponse, IGetRevenueGroupsResponse } from '@cbgms/api'
import { GetAccountancyLedgerResponse } from '@cbgms/api/modules/paymentmethodsrouting'

export const loadAdministration = (administrationUUID: string) =>
  AsyncAction<AdministrationResponse>({
    type: [types.LOAD_LEDGER_ADMINISTRATION, types.LOAD_LEDGER_ADMINISTRATION_SUCCESS, types.LOAD_LEDGER_ADMINISTRATION_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/accountancy/administrations/${administrationUUID}`
      }
    }
  })

export const loadAdministrations = (params: IPaginatedRequest = {}) =>
  AsyncAction<AdministrationListResponse>({
    type: [types.LOAD_LEDGER_ADMINISTRATIONS, types.LOAD_LEDGER_ADMINISTRATIONS_SUCCESS, types.LOAD_LEDGER_ADMINISTRATIONS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/administrations',
        params
      }
    }
  })

export const loadAdministrationLedgers = (administrationUUID: string, externalAdministrationUUID: string) =>
  AsyncAction<GetAccountancyLedgerResponse>({
    type: [
      types.LOAD_LEDGER_ADMINISTRATIONS_LEDGERS,
      types.LOAD_LEDGER_ADMINISTRATIONS_LEDGERS_SUCCESS,
      types.LOAD_LEDGER_ADMINISTRATIONS_LEDGERS_FAILED
    ],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/accountancy/administrations/${administrationUUID}/${externalAdministrationUUID}/ledgers`
      }
    }
  })

export const loadRevenueGroups = (params: IPaginatedRequest = {}) =>
  AsyncAction<IGetRevenueGroupsResponse>({
    type: [types.LOAD_LEDGER_REVENUE_GROUPS, types.LOAD_LEDGER_REVENUE_GROUPS_SUCCESS, types.LOAD_LEDGER_REVENUE_GROUPS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/accountancy/revenue-groups',
        params
      }
    }
  })

export const createLedger = (data: Partial<ILedger>) => ({
  type: [types.CREATE_LEDGER, types.CREATE_LEDGER_SUCCESS, types.CREATE_LEDGER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'POST',
      url: '/modules/accountancy/revenue-ledger-settings',
      data
    }
  }
})

export const updateLedger = (ledgerUUID: string, data: Partial<ILedger>) => ({
  type: [types.UPDATE_LEDGER, types.UPDATE_LEDGER_SUCCESS, types.UPDATE_LEDGER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: `/modules/accountancy/revenue-ledger-settings/${ledgerUUID}`,
      data
    }
  }
})

export const resetLedgerOptions = () => ({
  type: types.RESET_LEDGER_OPTIONS
})

export const loadRevenueLedgers = (params: IPaginatedRequest = {}) => ({
  type: [types.LOAD_REVENUE_LEDGERS, types.LOAD_REVENUE_LEDGERS_SUCCESS, types.LOAD_REVENUE_LEDGERS_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: '/modules/accountancy/revenue-ledger-settings',
      params
    }
  }
})

export const loadRevenueLedger = (ledgerUUID: string) => ({
  type: [types.LOAD_LEDGER, types.LOAD_LEDGER_SUCCESS, types.LOAD_LEDGER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/accountancy/revenue-ledger-settings/${ledgerUUID}`
    }
  }
})

export const removeRevenueLedger = (ledgerUUID: string, dryRun: boolean) => ({
  type: [types.REMOVE_REVENUE_LEDGER, types.REMOVE_REVENUE_LEDGER_SUCCESS, types.REMOVE_REVENUE_LEDGER_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'DELETE',
      url: `/modules/accountancy/revenue-ledger-settings/${ledgerUUID}`,
      params: {
        DryRun: dryRun
      }
    }
  }
})
